import { createAction } from 'redux-actions';

import {
  LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  LOG_OUT_NOT_CLEAR_DATA,
  RECOVERY_PASSWORD,
  RECOVERY_PASSWORD_ERROR,
  RECOVERY_PASSWORD_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS,
  AUTH_ANONYMOUS,
  AUTH_ANONYMOUS_ERROR,
  AUTH_ANONYMOUS_SUCCESS,
  CHECK_LOCAL_AUTH,
  CHECK_LOCAL_AUTH_SUCCESS,
  CHECK_LOCAL_AUTH_ERROR,
  SET_VERIFY_ITEM_CHANGE_PASSWORD,
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD,
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_ERROR,
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_SUCCESS,
  CHECK_LOCAL_AUTH_NOT_CLEAR_DATA_SUCCESS,
} from './type';

export const loginAction = createAction(LOGIN);
export const loginErrorAction = createAction(LOGIN_ERROR);
export const loginSuccessAction = createAction(LOGIN_SUCCESS);

export const logoutAction = createAction(LOGOUT);
export const logoutErrorAction = createAction(LOGOUT_ERROR);
export const logoutSuccessAction = createAction(LOGOUT_SUCCESS);

export const logOutNotClearDataAction = createAction(LOG_OUT_NOT_CLEAR_DATA);

export const recoveryPasswordAction = createAction(RECOVERY_PASSWORD);
export const recoveryPasswordErrorAction = createAction(
  RECOVERY_PASSWORD_ERROR,
);
export const recoveryPasswordSuccessAction = createAction(
  RECOVERY_PASSWORD_SUCCESS,
);

export const setVerifyItemChangePasswordAction = createAction(
  SET_VERIFY_ITEM_CHANGE_PASSWORD,
);

export const changePasswordAction = createAction(CHANGE_PASSWORD);
export const changePasswordErrorAction = createAction(CHANGE_PASSWORD_ERROR);
export const changePasswordSuccessAction = createAction(
  CHANGE_PASSWORD_SUCCESS,
);

export const authAnonymousAction = createAction(AUTH_ANONYMOUS);
export const authAnonymousErrorAction = createAction(AUTH_ANONYMOUS_ERROR);
export const authAnonymousSuccessAction = createAction(AUTH_ANONYMOUS_SUCCESS);

export const checkLocalAuthAction = createAction(CHECK_LOCAL_AUTH);
export const checkLocalAuthErrorAction = createAction(CHECK_LOCAL_AUTH_ERROR);
export const checkLocalAuthSuccessAction = createAction(
  CHECK_LOCAL_AUTH_SUCCESS,
);
export const checkLocalAuthNotClearDataSuccessAction = createAction(
  CHECK_LOCAL_AUTH_NOT_CLEAR_DATA_SUCCESS,
);

export const confirmVerifyCodeChangePasswordAction = createAction(
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD,
);
export const confirmVerifyCodeChangePasswordSuccessAction = createAction(
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_SUCCESS,
);
export const confirmVerifyCodeChangePasswordErrorAction = createAction(
  CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_ERROR,
);
